









































































import {Component, Vue, Prop, Mixins} from 'vue-property-decorator';
import {Option} from "@/types/CheckoutServerData";
import {PaymentOptions} from "@/types/CheckoutFormData";
import CreditCard from "./CreditCard.vue";
import OptionsIcons from "./OptionsIcons.vue";
import Invoice from "./Invoice.vue";
import {Mixin} from "@/mixins";
import NiceSelect from "@/components/NiceSelect.vue";
import store from '@/store';


@Component({
    components: {
        NiceSelect,
        CreditCard,
        Invoice,
        OptionsIcons
    },
    name: "OptionsList",
})
export default class OptionsList extends Mixins(Mixin) {
    @Prop()
    radios!: { [key: string]: Option };

    @Prop({default: () => '3'})
    value!: string|number; // 3 = Bank transfer, legacy -> PaymentOptions.CreditCard;

    store = store();

    PaymentOptions = PaymentOptions;

    pledgInstallmentOptions = {
        2: 2,
        3: 3,
        4: 4,
    };

    onOptionClick(key: number) {
        if (this.value === null || (this.value !== null && key !== parseInt(this.value.toString()))) {
            this.$emit('input', key);
            this.$emit('change')
        }
    }

    private get hasLockedOption(): boolean {
        return Object.keys(this.radios).findIndex(item => this.radios[item].isLocked) > -1;
    }
}
